import { useState } from "react";
import Avatar from "../../components/notes/Avatar";
import MediaGallery from "../../components/media/MediaGallery";
import DOMPurify from 'dompurify';
import TimeAgo from "../../components/timeAgo/TimeAgo";
import { FaClock } from "react-icons/fa";  

const PromotionDetailCard = ({images, videos, title, attachments, description, cost, type, state, city, pin_code, photo, creater, createdOn}) => {
  // eslint-disable-next-line no-unused-vars
  const [readMore, setReadMore] = useState(false);
  const charLimit = 200;
  // eslint-disable-next-line no-unused-vars
  const isLong = description?.length > charLimit;
  // eslint-disable-next-line no-unused-vars
  const toggleReadMore = () => setReadMore((prev) => !prev);
  const descriptionWords = description?.trim().split(' ') || [];
  const [showFullDescription, setShowFullDescription] = useState(false);
  const isLongDescription = descriptionWords.length > 50;
  const displayedDescription =
    isLongDescription && !showFullDescription
      ? descriptionWords.slice(0, 50).join(' ') + '...'
      : description;

  return (
    <div className="card shadow-sm border-0 rounded-4 overflow-hidden p-4 p-md-5 bg-white mb-4">
      {/* Media Gallery */}
      <div className="rounded-4 overflow-hidden mb-4 shadow-sm border">
        <MediaGallery
          images={images}
          promotion_videos={videos}
          attachments={attachments}
        />
      </div>

      {/* Creator & Meta Bar */}
      <div className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between p-3 rounded-3 bg-light border mb-4 gap-3">
        <div className="d-flex align-items-center gap-3">
          <Avatar src={photo} icon={creater} size={48} className="rounded-circle shadow-sm" />
          <div>
            <span className="text-muted small d-block">Listed By</span>
            <span className="fw-bold text-dark">{creater || "Anonymous"}</span>
          </div>
        </div>

        {createdOn && (
          <div className="d-flex align-items-center text-muted small ms-sm-auto">
            <FaClock className="me-2 text-primary" />
            <span>
              Listed <TimeAgo timestamp={createdOn} />
            </span>
          </div>
        )}
      </div>

      {/* Title & Price Header */}
      <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-start mb-4 gap-3">
        <div>
          <h2 className="fw-bold text-dark mb-2">{title || "Promotion Details"}</h2>
          <div className="d-flex flex-wrap gap-2 mt-2">
            {type && <span className="badge bg-primary-subtle text-primary fw-semibold px-3 py-2 fs-6">{type}</span>}
            {city && <span className="badge bg-secondary-subtle text-secondary fw-semibold px-3 py-2 fs-6">{city}</span>}
            {state && <span className="badge bg-info-subtle text-info fw-semibold px-3 py-2 fs-6">{state}</span>}
            {pin_code && <span className="badge bg-dark-subtle text-dark fw-semibold px-3 py-2 fs-6">{pin_code}</span>}
          </div>
        </div>

        {cost && (
          <div className="bg-success-subtle text-success p-3 rounded-3 text-center min-w-160 border border-success-subtle">
            <small className="text-muted d-block text-uppercase fw-semibold mb-1" style={{ fontSize: "11px" }}>
              Starting Price
            </small>
            <h3 className="fw-bold mb-0 text-success">₹{Number(cost).toLocaleString()}</h3>
          </div>
        )}
      </div>

      {/* Description Section */}
      {description && (
        <div className="p-4 rounded-3 bg-light border">
          <h5 className="fw-bold text-dark mb-3">About this Promotion</h5>
          <div
            className="text-secondary lh-lg"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(displayedDescription),
            }}
          />
          {isLongDescription && (
            <button
              className="btn btn-link p-0 mt-2 fw-semibold text-primary"
              onClick={() => setShowFullDescription(!showFullDescription)}
            >
              {showFullDescription ? "Read Less ↑" : "Read More ↓"}
            </button>
          )}
        </div>
      )}
    </div>
  );
}
export default PromotionDetailCard;